import React, { createContext } from 'react';

const AddProductsToSceneContext = createContext();

export default AddProductsToSceneContext;